import { render, staticRenderFns } from "./form-actions.vue?vue&type=template&id=52f16ee2&scoped=true&"
import script from "./form-actions.vue?vue&type=script&lang=js&"
export * from "./form-actions.vue?vue&type=script&lang=js&"
import style0 from "./form-actions.vue?vue&type=style&index=0&id=52f16ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f16ee2",
  null
  
)

export default component.exports